import * as React from 'react';
import {FunctionComponent} from 'react';
import {MachineConfiguration} from '../../../../Models/MachineConfiguration';
import {BoatType, toBoatTypeAbbreviation} from '../../../../Models/BoatType';
import {formatBoatTypeWeight} from '../../../Support/Formatting/formatWeight';
import {classNames} from '../../../Support/classNames';
import {MachineType, toMachineTypeDisplayName} from '../../../../Models/MachineType';
import {Weight} from '../../../../Domain/Weight';

interface OwnProps {
    machineConfigurations: MachineConfiguration[];
    className?: string;
}

export const MachineConfigurationBadges: FunctionComponent<OwnProps> = ({className, machineConfigurations}) => {
    if (machineConfigurations.length === 0) {
        return (
            <div className={classNames('d-flex flex-row mb-3 gap-2', className)}>
                <span className="badge rounded-pill bg-dark">Unknown boat</span>
            </div>
        );
    }

    if (
        machineConfigurations.length === 1 &&
        machineConfigurations[0].boat_type === BoatType.FOUR_X &&
        machineConfigurations[0].weight?.kilograms === 90
    ) {
        return (
            <div className={classNames('d-flex flex-row mb-3 gap-2', className)}>
                <span className="badge rounded-pill bg-dark">RP3 Split</span>
            </div>
        );
    }

    const boatTypes = machineConfigurations
        .map((machineConfiguration) => machineConfiguration.boat_type)
        .filter((boatType): boatType is BoatType => boatType !== null);
    const machineTypes = machineConfigurations
        .map((machineConfiguration) => machineConfiguration.machine_type)
        .filter((machineType): machineType is MachineType => machineType !== null)
        .filter((machineType) => machineType !== MachineType.RP3_T && machineType !== MachineType.RP3_S);
    const weights = machineConfigurations
        .map((machineConfiguration) => machineConfiguration.weight)
        .filter((weight): weight is Weight => weight !== null);
    return (
        <div className={classNames('d-flex flex-row mb-3 gap-2', className)}>
            {boatTypes.length > 0 && (
                <span className="badge rounded-pill bg-dark">
                    {boatTypes .map((boatType) => toBoatTypeAbbreviation(boatType)) .join(' / ')}
                </span>
            )}
            {weights.length > 0 && (
                <span className="badge rounded-pill bg-dark">
                    {weights.map((weight) => formatBoatTypeWeight(weight)).join(' / ')}
                </span>
            )}
            {machineTypes.length > 0 && (
                <span className="badge rounded-pill bg-dark">
                    {machineTypes.map((machineType) => toMachineTypeDisplayName(machineType)).join(' / ')}
                </span>
            )}
        </div>
    );
};
